'use client';
import React from 'react';

import { ProductPaginatedResult } from 'shared/types/result/PaginatedResult';
import ProductList from 'frontastic/tastics/products/product-list/components/ProductList';
import {
  ProductSearchProvider,
  useProductSearchContext,
} from 'frontastic/tastics/products/product-list/ProductSearchContext';

interface PLPPlaceholderProps {
  className?: string;
  searchContextValues?: any;
  categoryId?: string;
  title?: string;
  plpTitle?: string;
  defaultColor?: string;
}

const PLPPlaceholder: React.FC<PLPPlaceholderProps> = ({
  className,
  searchContextValues,
  categoryId,
  plpTitle,
  defaultColor,
}) => {
  // ==========================================================================================================================
  // THIS FALLBACK IN CASE THE SEARCH PROVIDER IS NOT AVAILABLE IS NEEDED FOR THE AMPLIENCE VISUALISATION FUNCTIONALITY TO WORK
  // ==========================================================================================================================
  if (!searchContextValues) {
    const VisualisationProductList = () => {
      const { productsPaginatedResults, isLoading, sort, setSort, offset, setOffset, activeFacets, setActiveFacets } =
        useProductSearchContext();

      const totalItems = productsPaginatedResults?.data?.total || 0;
      if (productsPaginatedResults?.data?.facets) {
        productsPaginatedResults.data.facets = [
          {
            name: 'Facets placeholder',
            buckets: [
              {
                key: 'Value 1',
                count: 596,
              },
              {
                key: 'Value 2',
                count: 223,
              },
            ],
            collapse: false,
          },
          {
            name: 'Facets placeholder 2',
            buckets: [
              {
                key: 'Value 3',
                count: 25,
              },
              {
                key: 'Value 4',
                count: 18,
              },
            ],
            collapse: false,
          },
          {
            name: 'Facets placeholder 3',
            buckets: [
              {
                key: 'Value 5',
                count: 25,
              },
              {
                key: 'Value 6',
                count: 18,
              },
            ],
            collapse: false,
          },
        ];
      }

      return (
        <>
          <div className="mt-8">
            <div className="flex flex-col items-center justify-between">
              <h1 id="title" className="pb-5 text-center text-2xl font-bold">
                PLP TITLE PLACEHOLDER
                {activeFacets.length === 1 &&
                  activeFacets[0].facetData?.terms?.length === 1 &&
                  ` | ${activeFacets[0].facetData?.terms?.[0]}`}
              </h1>
              {totalItems > 0 && (
                <p className="min-w-40 px-5 pb-8 pt-4 text-center text-sm font-normal">{totalItems} items</p>
              )}
            </div>
          </div>
          <div className={className}>
            <ProductList
              isLoading={isLoading}
              productsPaginatedResults={productsPaginatedResults as { data: ProductPaginatedResult }}
              activeFacets={activeFacets}
              setActiveFacets={setActiveFacets}
              offset={offset}
              setOffset={setOffset}
              sort={sort}
              setSort={setSort}
              isVisualisation={true}
              defaultColor={defaultColor}
            />
          </div>
        </>
      );
    };

    return (
      <ProductSearchProvider>
        <VisualisationProductList />
      </ProductSearchProvider>
    );
  }
  // ==========================================================================================================================

  const { productsPaginatedResults, isLoading, sort, setSort, offset, setOffset, activeFacets, setActiveFacets } =
    searchContextValues;
  const totalItems = productsPaginatedResults?.data?.total || 0;
  return (
    <>
      <div className="mt-8">
        <div className="flex flex-col items-center justify-between">
          <h1 id="title" className="pb-5 text-center text-2xl font-bold">
            {plpTitle}
            {activeFacets.length === 1 &&
              activeFacets[0].facetData?.terms?.length === 1 &&
              ` | ${activeFacets[0].facetData?.terms?.[0]}`}
          </h1>
          <div className="h-[1px] min-w-40 bg-primary-gold" />
          {totalItems > 0 && (
            <p className="min-w-40 px-5 pb-8 pt-4 text-center text-sm font-normal">{totalItems} items</p>
          )}
        </div>
      </div>
      <div className={className}>
        <ProductList
          isLoading={isLoading}
          productsPaginatedResults={productsPaginatedResults as { data: ProductPaginatedResult }}
          activeFacets={activeFacets}
          setActiveFacets={setActiveFacets}
          offset={offset}
          setOffset={setOffset}
          sort={sort}
          setSort={setSort}
          categoryId={categoryId}
          location="PLP Category"
          defaultColor={defaultColor}
        />
      </div>
    </>
  );
};

export default PLPPlaceholder;
